import React, { useState } from 'react';
import { AlertTriangle, Trash2, ChevronDown, ChevronRight, XCircle } from 'lucide-react';
import { useErrorLog, ErrorLogEntry } from '../services/errorLog';
function ErrorEntry({
  entry
}: {
  entry: ErrorLogEntry;
}) {
  const [expanded, setExpanded] = useState(false);
  const time = new Date(entry.timestamp);
  return <div className="border border-red-100 bg-white rounded-lg overflow-hidden" data-id="element-4298" data-mp="6wogt0vqa9nm">
      <button onClick={() => setExpanded(!expanded)} className="w-full flex items-start gap-3 px-4 py-3 text-left hover:bg-red-50/50 transition-colors" data-id="element-4299" data-mp="3fchxpgtz1n57">
        <XCircle className="h-4 w-4 text-red-500 mt-0.5 flex-shrink-0" data-id="element-4300" data-mp="3o4a4nhjsee51" />
        <div className="flex-1 min-w-0" data-id="element-4301" data-mp="3jdbnyguvze19">
          <div className="flex items-center gap-2 flex-wrap" data-id="element-4302" data-mp="3jc8t5xug0rg2">
            <span className="text-sm font-medium text-gray-900" data-id="element-4303" data-mp="2vnh9juux5hew">
              {entry.action}
            </span>
            <span className="text-xs text-gray-400" data-id="element-4304" data-mp="2rmnn75x4kao4">
              {time.toLocaleDateString()} {time.toLocaleTimeString()}
            </span>
          </div>
          <p className="text-sm text-red-700 mt-0.5 font-mono break-all" data-id="element-4305" data-mp="1j4rd6t42qfxk">
            {entry.message}
          </p>
        </div>
        {entry.payload && <div className="flex-shrink-0 mt-0.5" data-id="element-4306" data-mp="1sxor0ly4fgpu">
            {expanded ? <ChevronDown className="h-4 w-4 text-gray-400" data-id="element-4307" data-mp="1xw9r8lddi0ea" /> : <ChevronRight className="h-4 w-4 text-gray-400" data-id="element-4308" data-mp="107zou59odamn" />}
          </div>}
      </button>
      {expanded && entry.payload && <div className="border-t border-red-100 bg-gray-900 px-4 py-3 overflow-auto max-h-60" data-id="element-4309" data-mp="157kyb9mh11dm">
          <pre className="text-xs text-green-400 font-mono whitespace-pre-wrap break-words" data-id="element-4310" data-mp="1a5cmbsjzw3cj">
            {JSON.stringify(entry.payload, null, 2)}
          </pre>
        </div>}
    </div>;
}
export function ErrorLog() {
  const {
    entries,
    count,
    clear
  } = useErrorLog();
  return <div className="space-y-6" data-id="element-4311" data-mp="2qjcozba8673h">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-4312" data-mp="qi617i9o3iu4">
        <div className="min-w-0" data-id="element-4313" data-mp="qjzbr8nein7e">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-4314" data-mp="ljurr8nabacf">Error Log</h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-4315" data-mp="ziujip63g5ct">
            Track API errors and failed operations.{' '}
            {count > 0 ? `${count} error${count !== 1 ? 's' : ''} recorded.` : 'No errors recorded.'}
          </p>
        </div>
        {count > 0 && <button onClick={clear} className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-50 whitespace-nowrap flex-shrink-0" data-id="element-4316" data-mp="2sk4d1grpfpa">
            <Trash2 className="h-4 w-4" data-id="element-4317" data-mp="bsgm0j4qpeau" />
            Clear All
          </button>}
      </div>

      {/* Error List */}
      {count === 0 ? <div className="bg-white border border-gray-200 rounded-lg p-12 text-center" data-id="element-4318" data-mp="3g7ge83hpv8yh">
          <AlertTriangle className="mx-auto h-12 w-12 text-gray-300" data-id="element-4319" data-mp="3g5ngjdp2zz2m" />
          <h3 className="mt-3 text-sm font-semibold text-gray-900" data-id="element-4320" data-mp="361yqtfmfjnhp">
            No errors
          </h3>
          <p className="mt-1 text-sm text-gray-500" data-id="element-4321" data-mp="3avkqm77hvww3">
            When an API call fails, the error details will appear here.
          </p>
        </div> : <div className="space-y-2" data-id="element-4322" data-mp="313nb4o9geirk">
          {entries.map(entry => <ErrorEntry key={entry.id} entry={entry} data-id="element-4323" data-mp="3ouapnsdvk6n3" />)}
        </div>}
    </div>;
}